import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { MailX, CheckCircle, Loader2, ArrowLeft } from "lucide-react";
import { API } from "../utils/api";

const UnsubscribePage = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [error, setError] = useState("");

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        await axios.get(`${API}/unsubscribe/${userId}`);
        setStatus("success");
      } catch (err) {
        setStatus("error");
        setError(err.response?.data?.detail || "Une erreur est survenue");
      }
    };

    if (userId) {
      unsubscribe();
    } else {
      setStatus("error");
      setError("Lien invalide");
    }
  }, [userId]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-white flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center">
        {status === "loading" && (
          <>
            <Loader2 className="w-16 h-16 text-sky-600 animate-spin mx-auto mb-4" />
            <h1 className="text-xl font-bold text-slate-900 mb-2">Traitement en cours...</h1>
            <p className="text-slate-500">Veuillez patienter</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 mb-2">Désabonnement réussi</h1>
            <p className="text-slate-500 mb-6">
              Vous ne recevrez plus de notifications par email pour les nouvelles annonces.
            </p>
            <p className="text-sm text-slate-400 mb-6">
              Vous pouvez vous réabonner à tout moment depuis les paramètres de votre compte.
            </p>
            <Button
              onClick={() => navigate("/")}
              className="bg-sky-600 hover:bg-sky-700 text-white rounded-xl"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
          </>
        )}

        {status === "error" && (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <MailX className="w-10 h-10 text-red-600" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 mb-2">Erreur</h1>
            <p className="text-slate-500 mb-6">{error}</p>
            <Button
              onClick={() => navigate("/")}
              variant="outline"
              className="rounded-xl"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
          </>
        )}
      </Card>
    </div>
  );
};

export default UnsubscribePage;
